import ReactOnRails from 'react-on-rails';
import { SearchFormBox } from "../Components/SearchFormBox";
import { ResponsiveHeader } from "../Components/ResponsiveHeader";
import { ResponsiveFooter } from "../Components/ResponsiveFooter";
import { IndexText } from "../Components/IndexText";
import { ContentFrontpage } from "../Components/ContentFrontpage";
import { CheckWindowResize } from "../Components/CheckWindowResize";
import { USP } from "../Components/USP";
import { AccommodationDiscountTimer } from "../Components/AccommodationDiscountTimer";
import { AccommodationAcquisition } from "../Components/AccommodationAcquisition/AccommodationAcquisition";
import { SeoContent } from "../Components/SeoContent";
import { EBookDownload } from "../Components/EBookDownload/EBookDownload";
import { BookingTrustbox } from "../Components/BookingTrustbox";

ReactOnRails.register({ SearchFormBox });
ReactOnRails.register({ ResponsiveHeader });
ReactOnRails.register({ ResponsiveFooter });
ReactOnRails.register({ IndexText });
ReactOnRails.register({ CheckWindowResize });
ReactOnRails.register({ ContentFrontpage });
ReactOnRails.register({ USP });
ReactOnRails.register({ AccommodationDiscountTimer });
ReactOnRails.register({ AccommodationAcquisition });
ReactOnRails.register({ SeoContent });
ReactOnRails.register({ EBookDownload });
ReactOnRails.register({ BookingTrustbox });
